import { FormValidator } from "assets/js/validation";
import * as Alerts from "assets/js/alerts";


//remove specific parameters from the querystring
const url = new URL(window.location.href);
url.searchParams.delete('username');
url.searchParams.delete('expired');
history.replaceState({}, '', url);



const Validator = new FormValidator(ForgotPasswordForm);
const ErrorAlert = new Alerts.ErrorAlert(ForgotPasswordForm);
const Alert = new Alerts.Alert(ForgotPasswordForm);


ForgotPasswordForm.onsubmit = send;

async function send(e) {
	e.preventDefault();
	RecoverPassword.disabled = true;

	//client-side validation
	if (!await Validator.valid()) {
		RecoverPassword.disabled = false;
		return;
	}

	//submit form to server
	const options = {
		method: 'POST',
		body: new FormData(ForgotPasswordForm)
	};

	fetch(ForgotPasswordForm.action, options)
		.then(async response => {
			switch (response.status) {
				case 200:
					//recovery email sent
					if (document.getElementById('LinkExpired')) {
						LinkExpired.remove();
					}
					Alert.show("A password reset link has been sent to your email address.", { title: 'Email Sent' });
					break;

				default:
					//server-side errors
					ErrorAlert.show(await response.json());
					break;
			}

			RecoverPassword.disabled = false;
		});
}
